<template>
  <a-layout-content class="p-all">
    <a-row :gutter="{ xs: 0, lg: 8 }">
      <a-col :xs="24" :lg="8">
        <a-card>
          <span class="m-text-title" slot="title">Filter</span>
          <div class="d-flex flex-column">
            <a-input-search v-model="search" placeholder="Pencarian ... " />
            <a-collapse activeKey="1" class="m-top">
              <a-collapse-panel key="1">
                <span slot="header">Cari Lebih Lengkap</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Tanggal Transaksi</label>
                  <a-range-picker v-model="transactionDt" @change="searching" :format="getDefaultDateFormat" allowClear />
                </div>
              </a-collapse-panel>
            </a-collapse>
          </div>
        </a-card>
      </a-col>
      <a-col :xs="24" :lg="16">
        <H-Datalist
          title="Alokasi Pekerjaan"
          manifestLink="manifest.alokasi"
          editLink="edit.alokasi"
          editDraft="draft.alokasi"
          :dataListTab1="basedData"
          :dataListTab2="basedData"
          titleTab1="List"
          titleTab2="Draft"
          :isLoading="loadingTabs"
          :drafttoRevise="true"
          :extendedButton="true"
          :extendedButtonDeleteDraft="true"
          :showBadgeDraft="true"
          :showBadgeCount="draftBadgeCount"
        >
          <div slot="action-button">
            <!-- <a-button type="primary">
              <router-link
                :to="{ name: 'create.alokasi', params: {} }"
              >
                <a-icon type="plus" /> &nbsp;{{
                  isMobile ? "" : "Baru"
                }}
                </router-link
              >
            </a-button> -->
          </div>
        </H-Datalist>
        <!-- :createDisable="statusEntry ? false : true" -->
      </a-col>
    </a-row>
  </a-layout-content>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import DataListTabs from "@/components/DataListTabs";
import moment from "moment";
export default {
  name: "alokasiPekerjaan",
  components: {
    "H-Datalist": DataListTabs,
  },
  data() {
    return {
      transactionDt: [],
      search: "",
      dataList: [],
      basedList: [],
      originalBased: {
        list: [],
        draft: []
      },
      statusEntry: true,
      activedTabs: "1",
      loadingTabs: false,
      draftBadgeCount: 0
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getDefaultDateFormat", "getStandartFormatDate"]),
    basedData() {
      let output = [];

      this.dataList.forEach(data => {
        output.push({
          title: data.no_alokasi,
          subdesc: [
            this.moment(data.awal_periode).format(this.getDefaultDateFormat) + " - " + this.moment(data.akhir_periode).format(this.getDefaultDateFormat),
            data.departemen + " | " + data.posisi,
            data.site
          ],
          id: data.id_alokasi,
          status: data.status
        });
      });

      return output;
    },
    searching() {
      this.dataList = this.basedList;

      if (this.search) {
        this.dataList = this.dataList.filter(
          obj =>
            obj.no_alokasi.toLowerCase().indexOf(this.search.toLowerCase()) >=
            0 ||
            obj.akhir_periode
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            obj.awal_periode.toLowerCase().indexOf(this.search.toLowerCase()) >=
            0 ||
            obj.departemen.toLowerCase().indexOf(this.search.toLowerCase()) >=
            0 ||
            obj.posisi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.site.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.transactionDt.length > 0 && this.transactionDt[0] && this.transactionDt[1]) {
        let startDt = moment(this.transactionDt[0]).format(
          this.getStandartFormatDate
        );
        let endDt = moment(this.transactionDt[1]).format(
          this.getStandartFormatDate
        );
        this.dataList = this.dataList.filter(
          obj => obj.awal_periode >= startDt && obj.akhir_periode <= endDt
        );
      }

      if (!this.search && !this.transactionDt) {
        this.dataList = this.basedList;
      }
    }
  },
  created() {
    localStorage.setItem('crtalks_', "0");
    this.fetching();
  },
  mounted(){
    Event.$on("onTabCLick", this.processTabCLick);
  },
  destroy(){
    Event.$off("onTabCLick", this.processTabCLick);
  },
  methods: {
    moment,
    async fetching() {
      this.loadingTabs = true
      await axios({
        method: "get",
        url: this.$serviceUrl + "rekap_alokasi",
        params: {
          tlc: this.getAuth.username
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          //console.log(response.data.list);
          this.originalBased.list = response.data.list
          this.originalBased.draft = response.data.draft
          this.draftBadgeCount = this.originalBased.draft.length
          this.processTabCLick(this.activedTabs)
          
          this.statusEntry = response.data.status_entry;
          this.loadingTabs = false
        })
        .catch(err => {
          this.dataList = [];
          this.basedList = [];
          this.loadingTabs = false

          let responses = Object.assign({}, err);
          if(responses.response.data && responses.response.data.message){
            this.displayMessageValue("error-basic", responses.response.data.message);
          }else{
            this.displayMessageValue("error-other", responses);
          }
        });
    },
    processTabCLick(val){
      this.search = null
      this.transactionDt = [null,null]
      if(val=='1'){
        this.basedList = this.originalBased.list;
        this.dataList = this.originalBased.list;
      }else{
        this.basedList = this.originalBased.draft;
        this.dataList = this.originalBased.draft;
      }
    },
  }
};
</script>

<style></style>
